import { combineReducers } from "redux";
import { agencyReportsReducer } from "agency/reports/agencyReportsReducer";
import { officeReportsReducer } from "office/reports/officeReportsReducer";
export const reportsReducer = combineReducers({
    agencyReports: agencyReportsReducer,
    officeReports: officeReportsReducer
});
